// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--oCROd","icon":"dd31006766--icon--T0FNY","opened":"dd31006766--opened--NMPeJ"};